import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import LabServices from "../../api/Services/labServices"; 
import NodataImage from "../../Assets/Images/nodata.svg"; // adjust path

function MyLabReports() {
  const navigate = useNavigate();
  const userData = (() => { 
  try { return JSON.parse(localStorage.getItem("loginObj")); } 
  catch { return null; } 
})() || {};
  const [labReportList, setLabReport] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData?.code) return;
    setLoading(true);
    LabServices.getLabReportDetails({
      patientId: userData.code,
      docmentRequired: "Y",
    })
      .then((res) => {
        if (res.data) setLabReport(res.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [userData?.code]);

  const handleSelectReport = (lab) => {
    const type =
      lab.type.toLowerCase() === "pdf" ? "application/pdf" :
      lab.type.toLowerCase() === "jpg" ? "image/jpeg" :
      lab.type.toLowerCase() === "jpeg" ? "image/jpeg" :
      lab.type.toLowerCase() === "png" ? "image/png" :
      lab.type;

    // Only support pdf/image types
    const supported = ["pdf", "jpg", "jpeg", "png"];
    if (!supported.includes(lab.type.toLowerCase())) {
      alert("This file type is not supported for analysis.");
      return;
    }

    const query = new URLSearchParams({
      reportUrl: process.env.REACT_APP_IMG_BASEURL + lab.photoName,
      reportExtType: type,
      orderId: lab.orderId,
      popup: "true",
    }).toString();

    navigate(`/ask-caresathi?${query}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-6">
      {/* Header */}
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-[#004276] underline"
          >
            ← Back
          </button>
          <h1 className="text-xl font-semibold text-[#004276]">
            Select a Lab Report
          </h1>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          Tap a report to send it to CareSathi for analysis.
        </p>

        {/* Loading */}
        {loading && (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-4 border-[#004276] border-t-transparent rounded-full animate-spin" />
          </div>
        )}

        {/* Empty */}
        {!loading && labReportList.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 gap-4">
            <img src={NodataImage} alt="No data" className="w-16 opacity-50" />
            <p className="text-gray-400 text-sm">No lab reports found</p>
          </div>
        )}

        {/* Report list */}
        {!loading && labReportList.length > 0 && (
          <div className="flex flex-col gap-3">
            {labReportList
              .filter((r) => r.orderId?.length > 0)
              .map((lab, idx) => {
                const supported = ["pdf", "jpg", "jpeg", "png"].includes(
                  lab.type?.toLowerCase()
                );
                return (
                  <div
                    key={idx}
                    onClick={() => supported && handleSelectReport(lab)}
                    className={`bg-white rounded-xl border px-4 py-4 shadow-sm flex items-center justify-between transition-all
                      ${supported
                        ? "cursor-pointer hover:border-[#004276] hover:shadow-md"
                        : "opacity-40 cursor-not-allowed"
                      }`}
                  >
                    <div>
                      <p className="font-semibold text-[#004276] text-sm">
                        {lab.hospitalName || "Lab Report"}
                      </p>
                      <p className="text-xs text-gray-400 mt-0.5">
                        Order ID: {lab.orderId}
                      </p>
                      {lab.createdDate && (
                        <p className="text-xs text-gray-400">
                          Date: {new Date(lab.createdDate).toLocaleDateString()}
                        </p>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs px-2 py-1 rounded-full bg-[#EAF3FA] text-[#004276] font-medium uppercase">
                        {lab.type}
                      </span>
                      {supported && (
                        <span className="text-[#004276] text-lg">→</span>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyLabReports;